module.exports = __webpack_public_path__ + "static/media/gg-circle.100bdee6.svg";